import { desaturatedColors } from '@/constants/material-colors'

export const getRandomColor = () => {
  const randomIndex = Math.floor(Math.random() * desaturatedColors.length)
  return desaturatedColors[randomIndex]
}